var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { JobType } from './job';
export var OutOfSyncState;
(function (OutOfSyncState) {
    OutOfSyncState["LearningClassifier"] = "Learning Classifier";
    OutOfSyncState["StaticClassifier"] = "Static Classifier";
    OutOfSyncState["AnomalyRecognizer"] = "Anomaly Recognizer";
    OutOfSyncState["AnomalyHiFi"] = "Anomaly Hi-Fi";
    OutOfSyncState["WhiteLabelLearningClassifier"] = "Working Brain";
    OutOfSyncState["WhiteLabelStaticClassifier"] = "Firefly DL Brain";
    OutOfSyncState["Detector"] = "Detector";
})(OutOfSyncState || (OutOfSyncState = {}));
export var SidebarClass;
(function (SidebarClass) {
    SidebarClass["EXPANDED"] = "has-expanded-navbar";
    SidebarClass["COLLAPSED"] = "has-collapsed-navbar";
})(SidebarClass || (SidebarClass = {}));
var NavSidebarProvider = /** @class */ (function () {
    function NavSidebarProvider() {
        this.currentMetadataSubscription = new BehaviorSubject(undefined);
        this.contentClass = SidebarClass.EXPANDED;
        this.contentClassSubscription = new BehaviorSubject(SidebarClass.EXPANDED);
    }
    Object.defineProperty(NavSidebarProvider.prototype, "currentMetadata", {
        get: function () {
            return this._currentMetadata;
        },
        set: function (projectID) {
            this._currentMetadata = projectID;
            this.currentMetadataSubscription.next(this._currentMetadata);
        },
        enumerable: true,
        configurable: true
    });
    NavSidebarProvider.prototype.getContentClass = function () {
        return this.contentClass;
    };
    NavSidebarProvider.prototype.setContentClass = function (contentClass) {
        this.contentClass = contentClass;
        this.contentClassSubscription.next(this.contentClass);
    };
    /**
     * Return a boost job type associated with the specified outOfSyncState,
     * indicating which type of job will bring the brain version type
     * back into sync
     */
    NavSidebarProvider.prototype.getJobTypeForOutOfSyncState = function (outOfSyncState) {
        switch (outOfSyncState) {
            case OutOfSyncState.AnomalyRecognizer:
            case OutOfSyncState.LearningClassifier:
            case OutOfSyncState.WhiteLabelLearningClassifier:
                return JobType.Retrain;
            case OutOfSyncState.Detector:
                return JobType.Train;
            case OutOfSyncState.WhiteLabelStaticClassifier:
            case OutOfSyncState.StaticClassifier:
                return JobType.Freeze;
        }
        throw new Error("getJobTypeForOutOfSyncState() does not support OutOfSyncState " + outOfSyncState);
    };
    NavSidebarProvider = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [])
    ], NavSidebarProvider);
    return NavSidebarProvider;
}());
export { NavSidebarProvider };
//# sourceMappingURL=nav-sidebar.js.map


// WEBPACK FOOTER //
// ./src/providers/nav-sidebar.ts.pre-build-optimizer.js